import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Note on localStorage usage:
// `scudononni_client_id` is an anonymous random UUID generated client-side.
// It contains NO personal data — it's only used to count the daily 4-verification
// quota for a given browser. The same role a session cookie would play. Since
// there is no authentication or sensitive token to protect, localStorage is the
// appropriate, simplest storage; XSS exposure here is not a meaningful risk
// (an attacker would only learn an opaque, anonymous quota identifier).
const CLIENT_ID_KEY = "scudononni_client_id";

export function getClientId() {
  let id = localStorage.getItem(CLIENT_ID_KEY);
  if (!id) {
    id =
      (window.crypto && window.crypto.randomUUID && window.crypto.randomUUID()) ||
      `c-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    localStorage.setItem(CLIENT_ID_KEY, id);
  }
  return id;
}

export async function fetchUsage() {
  const cid = getClientId();
  const { data } = await axios.get(`${API}/usage/${cid}`);
  return data;
}

export async function analyzeText(text) {
  const cid = getClientId();
  const { data } = await axios.post(`${API}/analyze/text`, {
    client_id: cid,
    text,
  });
  return data;
}

export async function analyzeImage(imageBase64) {
  const cid = getClientId();
  const { data } = await axios.post(`${API}/analyze/image`, {
    client_id: cid,
    image_base64: imageBase64,
  });
  return data;
}

export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
